import { ComponentProps, ReactNode } from 'react';
import { createStylesContext } from '@chakra-ui/react';
import { createContext } from '@chakra-ui/react-utils';
import { DropdownProps } from './DropdownProps';

const [DropdownStylesProvider, useDropdownStyles] = createStylesContext('Dropdown');

export type DropdownEventArgs<T> = { value: T; index: number | undefined; label: ReactNode };

type DropdownContext<T> = {
  formValue: T;
  isMultiSelect: boolean;
  onOptionSelected: (arg: DropdownEventArgs<T>) => void;
  listRef: React.RefObject<(HTMLElement | null)[]>;
  searchValue: string;
  searchRef: React.Ref<HTMLInputElement>;
  searchOnChange: (sv: string) => void;
  searchOnSubmit: () => void;
  filter?: string;
  activeIndex?: number | null;
  getItemProps: (userProps?: React.HTMLProps<HTMLElement> | undefined) => Record<string, unknown>;
  size: DropdownProps<unknown>['size'];
};

const [DropdownContextProvider, useDropdownContext] = createContext<DropdownContext<unknown>>();

function useDropdownContextTyped<T>(): DropdownContext<T> {
  return useDropdownContext() as unknown as DropdownContext<T>;
}

const DropdownProvider = <T,>({
  children,
  context,
  styles,
}: {
  styles: ComponentProps<typeof DropdownStylesProvider>['value'];
  children: ReactNode;
  context: DropdownContext<T>;
}) => (
  <DropdownContextProvider value={context as DropdownContext<unknown>}>
    <DropdownStylesProvider value={styles}>{children}</DropdownStylesProvider>
  </DropdownContextProvider>
);

export { DropdownProvider, useDropdownContextTyped as useDropdownContext, useDropdownStyles };
